module.exports = __webpack_public_path__ + "img/cookies.512a50db.svg";